import React, { FC, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Link, Typography } from '@mui/material'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { Android } from '@emotion-icons/material-outlined/Android'
import { Apple } from '@emotion-icons/remix-fill/Apple'
import { Shapes } from 'src/components/theme'
import logo from 'src/assets/images/logo.svg'
import { FlexColumn } from 'src/components/flex-containers'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: white;
  justify-content: center;
  padding: ${Shapes.spacing[6]}px;
  gap: ${Shapes.spacing[6]}px;
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  margin-top: 32px;
`

type MobileDownloadProps = {
  children?: React.ReactNode
}

const MobileDonwloadContent: FC = () => {
  const onClickAndroid = () => {
    window.open('https://play.google.com/store/apps/details?id=com.alphamap.mobile.v2', '_blank')
  }

  const onClickApple = () => {
    window.open('https://apps.apple.com/us/app/alphamap/id1671866587', '_blank')
  }

  return (
    <Container>
      <img height={120} src={logo} alt="AlphaMap" />
      <FlexColumn gap={Shapes.spacing[2]}>
        <Typography variant="title1" textAlign="center">
          Thank you for signing up for AlphaMap!
        </Typography>
        <Typography variant="textmdm" textAlign="center" mt={2}>
          You can visit{' '}
          <Link href="https://app.alphamap.com" target="_blank">
            app.alphamap.com
          </Link>{' '}
          on your desktop for the full experience, or download our mobile app for a simplified version of the platform.
        </Typography>
      </FlexColumn>
      <ButtonsWrapper>
        <ButtonWithIcon inverted onClick={onClickApple}>
          <Apple size={24} />
          Download on Apple
        </ButtonWithIcon>
        <ButtonWithIcon inverted onClick={onClickAndroid}>
          <Android size={24} />
          Download on Android
        </ButtonWithIcon>
      </ButtonsWrapper>
    </Container>
  )
}

export const MobileDownload: FC<MobileDownloadProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobileDevice = () => {
      const isMobile = /Mobi|Android/i.test(navigator.userAgent)
      const isSmallScreen = window.matchMedia('(max-width: 767px)').matches

      if (isMobile || isSmallScreen) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    checkMobileDevice()
    window.addEventListener('resize', checkMobileDevice)

    return () => {
      window.removeEventListener('resize', checkMobileDevice)
    }
  }, [])

  return <>{isMobile ? <MobileDonwloadContent /> : children}</>
}
